<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryOnLoad="false" :queryHandler="queryHandler"></swb-query-sort-area>

        <div class="table-layout">
            <el-table :data="dataList" border style="width: 100%" @current-change="handleCurrentChange">
                <el-table-column width="55">
                    <template slot-scope="rows">
                        <div class="copy-radio ml15" :class="{'circle' : selectTpl!= null && selectTpl.id == rows.row.id}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="名称" align="left"></el-table-column>
                <el-table-column prop="desc" label="说明" align="left"></el-table-column>
                <el-table-column prop="creatorName" label="创建人" align="left" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center" width="150"></el-table-column>
                <el-table-column prop="id" label="操作" align="left" width="300">
                    <template slot-scope="rows">
                        <div class="swb-btn swb-btn-link" @click="viewDetail(rows.row.id)">查看详情</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="pagination-layout">
            <el-pagination background v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { getDefaultPageSizes } from '../../app.conf'

    import shopDevcApi from '../../api/shopDevc'

    import SwbDevcInfoFormTplDetail from './DevcInfoFormTplDetail'
    Vue.regist(SwbDevcInfoFormTplDetail);

    let mockConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "valueType": "String",
                "label": "名称",
                "code": "name",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "创建人",
                "code": "creatorName",
                "basic": true
            },
            {
                "type": "Date2",
                "valueType": "String",
                "label": "创建时间",
                "code": "createTime",
                "basic": true
            }
        ],
        "sortFields": []
    };

    export default {
        name: 'swb-devc-info-form-tpl-list-select',
        desc: '设备信息单模版选择',
        props: {
            selectId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                // 过滤信息
                queryConfig: mockConfigData,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                // 其他信息
                dataList: [],
                selectTpl: null
            }
        },
        created: function () {
            if(this.selectId != null) {
                this.selectTpl = Utils.merge({}, {id: this.selectId});
            }
            this.pageSize = this.pageSizes.first();
            this.getDataList();
        },
        methods: {
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getDataList();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDataList();
            },
            getDataList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                // 调用查询接口
                shopDevcApi.getDevcInfoFormTplList(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        self.dataList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 查看详情
            viewDetail(id){
                let theDlg = Vue.$showDialog({
                    title: "设备信息单模版-详情",
                    width: 1300,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    template: '<div>' +
                    '<swb-devc-info-form-tpl-detail :id="id" ref="swb_devc_info_form_tpl_save"></swb-devc-info-form-tpl-detail>' +
                    '</div>',
                    data: {
                        id: id
                    }
                });
            },
            handleCurrentChange: function (val) {
                this.selectTpl = Utils.merge({}, val);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let selectTpl = self.selectTpl;
                if(selectTpl != null) {
                    result.type = 'info';
                    result.data = selectTpl;
                } else {
                    result.type = 'warn';
                    result.message = '请选择信息单模版！';
                }
                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/DevcInfoFormTplListForSelect.vue